var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Icon from "@irati/ui/src/Icon";
import { perkbox } from "@irati/ui/src/global/colors";
import { FormattedMessage } from "@irati/utils/lang";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import Hr from "@irati/ui/src/Layout/Hr";
import { TenantOnboardingStepStates } from "@irati/types";
import { generateReadableStepNumber, getStepDetails, orderSteps, isValidStep } from "../../helpers";
import { TooltipBase } from "./";
import { StepRow, IconContainer } from "./styled";
import { StepLabel, StepNumberContainer, TopArrow } from "../SideBar/styled";
var ChecklistSetupTooltip = /** @class */ (function (_super) {
    __extends(ChecklistSetupTooltip, _super);
    function ChecklistSetupTooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            // If click is made outside tooltip, close it
            if (!_this.divRef.current.contains(e.target)) {
                _this.props.handleClose();
            }
        };
        _this.divRef = React.createRef();
        return _this;
    }
    ChecklistSetupTooltip.prototype.componentWillMount = function () {
        document.addEventListener("mousedown", this.handleClick, false);
    };
    ChecklistSetupTooltip.prototype.componentWillUnmount = function () {
        document.removeEventListener("mousedown", this.handleClick, false);
    };
    ChecklistSetupTooltip.prototype.render = function () {
        var _a = this.props, handleClose = _a.handleClose, steps = _a.steps;
        return (React.createElement("div", { ref: this.divRef },
            React.createElement(TooltipBase, { handleClose: handleClose },
                React.createElement(TopArrow, null),
                React.createElement(H3, { tiny: true },
                    React.createElement(FormattedMessage, { id: "setup_tenant.tooltip.checklist.title" })),
                React.createElement(Para, null,
                    React.createElement(FormattedMessage, { id: "setup_tenant.tooltip.checklist.body" })),
                React.createElement(Hr, null),
                steps &&
                    orderSteps(steps.filter(isValidStep)).map(function (step, index) {
                        var title = getStepDetails(step).title;
                        return (React.createElement(StepRow, { key: index + 1 + "#" + step.stepId },
                            React.createElement(StepNumberContainer, null,
                                React.createElement(Para, null, generateReadableStepNumber(index + 1))),
                            React.createElement(StepLabel, null,
                                React.createElement(FormattedMessage, { id: title })),
                            React.createElement(IconContainer, null,
                                step.state === TenantOnboardingStepStates.Done && React.createElement(Icon, { size: 20, icon: "tick", flush: true, color: perkbox.blue }),
                                step.state === TenantOnboardingStepStates.Skipped && React.createElement(Icon, { icon: "circleHollow", color: perkbox.blue }))));
                    }))));
    };
    return ChecklistSetupTooltip;
}(PureComponent));
export default ChecklistSetupTooltip;
